/**
 * Vestuario: trajes del aventurero que se desbloquean con las monedas acumuladas entre partidas.
 * Se guarda en el dispositivo (localStorage); sin almacenamiento funciona solo en memoria.
 */
const KEY = 'dopamine-runner.wardrobe.v1';

export const SKINS = [
  { id: 'explorer', name: 'Explorador', price: 0, jacket: 0x7a5530, scarf: 0xc63a2b, hat: 0x5c3c1f, pack: 0x6f5a35 },
  { id: 'ranger', name: 'Guardabosques', price: 150, jacket: 0x3f6b35, scarf: 0xe8892b, hat: 0x24402a, pack: 0x5a4a2c },
  { id: 'night', name: 'Nocturno', price: 400, jacket: 0x1f2a44, scarf: 0x3fd0e8, hat: 0x111622, pack: 0x2e3442 },
  { id: 'hunter', name: 'Cazador', price: 800, jacket: 0x9a2a22, scarf: 0x1a1a1a, hat: 0xb08a55, pack: 0x4a3a28 },
  { id: 'gold', name: 'Leyenda dorada', price: 2000, jacket: 0xd9a520, scarf: 0xf4f0e6, hat: 0xffd23a, pack: 0x8a6a20, glow: 0x3a2800 },
];

export class Wardrobe {
  constructor(storage = globalThis.localStorage) {
    this.storage = storage;
    const saved = this.#load();
    this.owned = new Set(['explorer', ...(saved.owned ?? [])]);
    this.selected = this.owned.has(saved.selected) ? saved.selected : 'explorer';
    this.spent = saved.spent ?? 0;
  }

  get skin() {
    return SKINS.find((s) => s.id === this.selected);
  }

  /** Monedas disponibles: todo lo ganado (partidas + misiones) menos lo gastado. */
  balance(earned) {
    return Math.max(0, earned - this.spent);
  }

  /** Equipa el traje; si no lo tiene y le llega, lo compra. Devuelve 'equipped' | 'bought' | 'poor'. */
  choose(id, earned) {
    const skin = SKINS.find((s) => s.id === id);
    if (!skin) return 'poor';
    let result = 'equipped';
    if (!this.owned.has(id)) {
      if (this.balance(earned) < skin.price) return 'poor';
      this.spent += skin.price;
      this.owned.add(id);
      result = 'bought';
    }
    this.selected = id;
    this.#save();
    return result;
  }

  /** Gasta monedas en otra cosa (segunda oportunidad). */
  spend(amount) {
    this.spent += amount;
    this.#save();
  }

  #load() {
    try {
      return JSON.parse(this.storage?.getItem(KEY) ?? '{}') ?? {};
    } catch {
      return {};
    }
  }

  #save() {
    try {
      this.storage?.setItem(KEY, JSON.stringify({ owned: [...this.owned], selected: this.selected, spent: this.spent }));
    } catch {}
  }
}
